import { useCallback, useId } from 'react';
import { useFocusEffect } from 'expo-router';

import { useNoticeBannersStackActions } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const useNoticeToastBottomOffset = (params: Params) => {
  const { offset } = params;

  const ownerId = useId();
  const { setToastBottomOffset, resetToastBottomOffset } = useNoticeBannersStackActions();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const liftToastsWhileFocused = useCallback(() => {
    setToastBottomOffset(ownerId, offset);

    return () => {
      resetToastBottomOffset(ownerId);
    };
  }, [offset, ownerId, resetToastBottomOffset, setToastBottomOffset]);

  // ─── Effects ───────────────────────────────────────────────────────────────

  useFocusEffect(liftToastsWhileFocused);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = { offset: number };
